export const BASE_URL = "https://api.github.com";

export const repos = "repos";
export const users = "users";

export const commits = "commits";
